import { checkSomeVehicleHaveLeaseDeal } from 'site-modules/upper-funnel/utils/vehicle-lease-deal-match';

export const buildLeaseDealsHiddenGemsCriticalCss = ({ vehicleEditorialRankings, leaseDeals }) => {
  const VIEWPORT_CARDS_NUMBER = 3;

  const viewportCards = vehicleEditorialRankings?.[0]?.segmentRatings?.slice(0, VIEWPORT_CARDS_NUMBER) ?? [];

  if (checkSomeVehicleHaveLeaseDeal({ vehicles: viewportCards.map(({ modelYear }) => modelYear), leaseDeals })) {
    return { withLeaseDealsLink: true };
  }

  return {};
};
